import React from "react";

export default function FieldCard({
  label,
  unit,
  children,
  error,
  warning,
}) {
  return (
    <div
      className={`rounded-sm border px-3 py-3 shadow-sm ${
        error
          ? "border-[#d13438] bg-[#fff4f4]"
          : warning
          ? "border-[#c19c00] bg-[#fff9e6]"
          : "border-[#edebe9] bg-white"
      }`}
    >
      <div className="mb-2 flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="text-sm font-medium leading-5 text-[#201f1e]">
            {label}
          </div>
        </div>

        {unit ? (
          <div className="shrink-0 rounded-sm border border-[#edebe9] bg-[#faf9f8] px-2 py-1 text-[10px] uppercase tracking-wide text-[#605e5c]">
            {unit}
          </div>
        ) : null}
      </div>

      <div>{children}</div>

      {error ? (
        <p className="mt-2 text-xs leading-5 text-[#d13438]">
          {error}
        </p>
      ) : warning ? (
        <p className="mt-2 text-xs leading-5 text-[#8a6d00]">
          {warning}
        </p>
      ) : null}
    </div>
  );
}